import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SfoUiJSONSchema7 } from '../../../../metadata.model';
import { NgIf, NgFor } from '@angular/common';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
    selector: 'sfo-radio-group-input',
    templateUrl: './radio-group-input.component.html',
    imports: [
        NgIf,
        MatRadioGroup,
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        MatRadioButton,
    ],
})
export class RadioGroupInputComponent implements OnInit {
  @Input() schema!: SfoUiJSONSchema7;
  @Input() aFormControl!: FormControl;
  @Input() defaultValue: any;

  ngOnInit(): void {
    if (this.aFormControl && this.aFormControl.value === undefined) {
      const valueToSet = this.defaultValue ?? this.schema.default;
      if (valueToSet !== undefined) {
        this.aFormControl.setValue(valueToSet, { emitEvent: false });
      }
    }
  }
}
